import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "gather-export",
  "element-loading-text": "加载中..."
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("团队订单");

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "position": "relative",
    "top": "3px"
  }
}, "聚合导出", -1);

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "按同一业务员与相同收货地址进行订单聚合展示与导出", -1);

const _hoisted_5 = {
  class: "total"
};
const _hoisted_6 = {
  class: "expand-table"
};
const _hoisted_7 = {
  class: "footer"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认导出");

const _hoisted_10 = {
  class: "modal-container"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定");

import { ref, onMounted } from 'vue';
import { flatten } from 'lodash-es';
import { useRouter, useRoute } from 'vue-router';
import { getOrderGatherList, orderGatherExport } from '@/request';
import axios from '@/request/createAxiosInstalce';
import { ElMessage } from 'element-plus';
export default {
  name: 'orderGatherExport',

  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    onMounted(() => getList());
    const table = ref([]);
    const total = ref('');
    const tplList = ref([]);
    const loading = ref(false);

    function getList() {
      loading.value = true;

      let params = _objectSpread(_objectSpread({}, route.query), {}, {
        isMergeQuery: 1
      });

      getOrderGatherList(params).then(res => {
        let {
          tips,
          supplierOrderMergeList = [],
          exportTypeList = []
        } = res;
        total.value = tips;
        table.value = supplierOrderMergeList; // table.value = supplierOrderMergeList.map(item => {
        //     item.checked = true
        //     if (Array.isArray(item.list)) {
        //         item.list.forEach(subItem => subItem.checked = true)
        //     }
        //     return item
        // })

        tplList.value = exportTypeList;
      }).finally(() => loading.value = false);
    }

    const orderCodeSplitList = ref([]);
    const orderExportType = ref(null);
    const tplModalShow = ref(false);

    function submit() {
      orderCodeSplitList.value = flatten(table.value.map(item => item.list)).filter(item => item.checked).map(item => item.orderCodeSplit);

      if (orderCodeSplitList.value.length === 0) {
        ElMessage.warning('请选择导出数据');
        return;
      }

      if (tplList.value.length > 1) {
        tplModalShow.value = true;
        orderExportType.value = tplList.value[0].dictitemCode;
        return;
      }

      orderExportType.value = tplList.value[0].dictitemCode;
      exportConfirm();
    }

    function exportConfirm() {
      let body = {
        orderCodeSplitList: orderCodeSplitList.value,
        orderExportType: orderExportType.value
      };
      orderGatherExport(body).then(res => {
        if (!res.success) {
          ElMessage.error(res.msg);
          return;
        }

        window.open(res.data.fileUrl, '_blank');
        tplModalShow.value = false;
      });
    }

    function tableCheckboxChange(item) {
      if (!Array.isArray(item.list)) return;
      item.list.forEach(subItem => subItem.checked = item.checked);
    }

    function expandTableCheckboxChange(parentItem) {
      parentItem.checked = parentItem.list.every(item => item.checked);
    }

    function back() {
      router.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            link: "",
            onClick: back
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        _: 1
      }), _hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(total.value), 1), _createVNode(_component_el_table, {
        data: table.value,
        "default-expand-all": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "expand"
        }, {
          default: _withCtx(props => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_table, {
            data: props.row.list
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "选择",
              width: "60"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_checkbox, {
                modelValue: scope.row.checked,
                "onUpdate:modelValue": $event => scope.row.checked = $event,
                onChange: $event => expandTableCheckboxChange(props.row, scope.row)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
              _: 2
            }, 1024), _createVNode(_component_el_table_column, {
              label: "客户名称",
              prop: "custName"
            }), _createVNode(_component_el_table_column, {
              label: "下单时间",
              prop: "createAt"
            }), _createVNode(_component_el_table_column, {
              label: "品规数",
              prop: "prodCount",
              width: "80"
            }), _createVNode(_component_el_table_column, {
              label: "结算金额",
              prop: "totalPrice",
              width: "120"
            }), _createVNode(_component_el_table_column, {
              label: "发货方",
              prop: "branchName"
            })]),
            _: 2
          }, 1032, ["data"])])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "选择",
          width: "60"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_checkbox, {
            modelValue: scope.row.checked,
            "onUpdate:modelValue": $event => scope.row.checked = $event,
            onChange: $event => tableCheckboxChange(scope.row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "业务员",
          prop: "linkMan",
          width: "160"
        }), _createVNode(_component_el_table_column, {
          label: "收货地址",
          prop: "receiverAddress"
        }), _createVNode(_component_el_table_column, {
          label: "收货人",
          prop: "receiverName",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          label: "收货联系方式",
          prop: "receiverPhone"
        })]),
        _: 1
      }, 8, ["data"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
        onClick: back
      }, {
        default: _withCtx(() => [_hoisted_8]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: submit
      }, {
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      })]), _createVNode(_component_el_dialog, {
        modelValue: tplModalShow.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => tplModalShow.value = $event),
        title: "选择导出模板类型"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => tplModalShow.value = false)
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: exportConfirm
        }, {
          default: _withCtx(() => [_hoisted_12]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_radio_group, {
          modelValue: orderExportType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => orderExportType.value = $event)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tplList.value, item => {
            return _openBlock(), _createBlock(_component_el_radio, {
              label: item.dictitemCode,
              key: item.dictitemCode
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.dictitemName), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, loading.value]]);
    };
  }

};